<app-common-header-layout
  [showHeaderCta]="true"
  [trackingScreenName]="trackingScreenName"
  [trackingObject]="trackingObject$ | async"
>
  <app-heading
    [title]="'SELECT_ACCOUNT.TITLE' | translate"
    [subtitle]="'SELECT_ACCOUNT.SUBTITLE_MESSAGE' | translate"
    [hasLessMargin]="!!(error$ | async)"
  >
  </app-heading>

  <div class="form-body">
    <app-form-banner
      *ngIf="error$ | async as message"
      [message]="message"
      bannerStyle="error"
    ></app-form-banner>

    <app-select-account-form
      [accounts]="userAccount?.accounts"
      (buttonSubmit)="loginAccountByCompany($event)"
    >
    </app-select-account-form>
  </div>

  <i2g-full-screen-spinner
    [show]="processing$ | async"
  ></i2g-full-screen-spinner>
</app-common-header-layout>
